// extracted by mini-css-extract-plugin
module.exports = {"container":"LibrarySong_container__19xjd","songDescription":"LibrarySong_songDescription__3JzeN","selected":"LibrarySong_selected__6UfrW"};